export const RequestsData = [
    {
        customername: 'Vikrama Vyas',
        date: '20th June, 2024',
        customerlocation: 'Akurdi, Pune',
        iscurrent: false,
        servicerequest: 'Dusting'
    },
    {
        customername: 'Kavya Gandhi',
        date: '20th June, 2024',
        customerlocation: 'Viman Nagar, Pune',
        iscurrent: false,
        servicerequest: 'Household Help'
    },
    {
        customername: 'Vanraj Joshi',
        date: '20th June, 2024',
        customerlocation: 'Kharadi, Pune',
        iscurrent: true,
        servicerequest: 'Utensils Cleaning'
    },
];

export default RequestsData;